import { PageWrapper } from 'layout/PublicLayout/Wrappers';
import View from './ClubView';
import MapView from './MapView';
import SingleClubMapView from './SingleClubMapView';
import ClubsGrid from './Components/ClubsGrid';
import { Suspense } from 'react';
import { useTranslation } from 'react-i18next';

const LoadingFallback = () => {
    const { t } = useTranslation();

    return <div>{t('Loading')}</div>;
};

export const PublicClubView = () => {
    return (
        <PageWrapper>
            <Suspense fallback={<LoadingFallback />}>
                <View />
            </Suspense>
        </PageWrapper>
    );
};

export const PublicClubDetails = () => {
    return (
        <PageWrapper>
            <ClubsGrid />
        </PageWrapper>
    );
};

export const PublicClubsMapView = () => {
    return (
        <PageWrapper>
            <Suspense fallback={<LoadingFallback />}>
                <MapView />
            </Suspense>
        </PageWrapper>
    );
};

export const PublicSingleClubMapView = () => {
    return (
        <PageWrapper>
            <Suspense fallback={<LoadingFallback />}>
                <SingleClubMapView />
            </Suspense>
        </PageWrapper>
    );
};

export default { PublicClubView, PublicClubDetails, PublicClubsMapView, PublicSingleClubMapView };
